import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import useStateRef from "react-usestateref";
import { useHistory } from 'react-router-dom';
import HeaderNavTabContainer from "./HeaderNavTabContainer";
import MegaMenu from "./MegaMenu";
import '../../styles/CbOSECustomCss.css'

function CbOSEHeaderContainer({ containerObject, templateName, contentId, dataZone }) {
    const [autoSuggestionResult, setAutoSuggestionResult] = useState("")
    const [searchValue, setSearchValue, searchValueRef] = useStateRef('')
    const [defaultSearchValue, setDefaultSearchValue, defaultSearchValueRef] = useStateRef(containerObject && containerObject.searchQuery ? containerObject.searchQuery : "")
    const [searchPageUrlState, setSearchPageUrlState] = useState(containerObject && containerObject.searchPageUrl ? containerObject.searchPageUrl : "ose/browse/product-search-results");

    const history = useHistory();

    function handleSubmitData(event) {
        event.preventDefault()
        var formData = new FormData(event.target);
        var check = formData.get("q");
        if (check != "" && check.length >= 1) {
            history.push("/" + searchPageUrlState + "?q=" + encodeURIComponent(check) + "&product.type=Product&tab=p")
        }
    }

    useEffect(() => {
        window.addEventListener('click', function (e) {
            //if (props.containerObject && props.containerObject.attributes.isCheckOutPage != "Y") {
            var taEle = document.getElementById('ta-mobile');
            if (taEle && taEle.contains(e.target)) {
                // Clicked in box
            } else {
                // Clicked outside the box
                setAutoSuggestionResult("")
                //setSearchProductDetails("")
            }
            //}
        });
    }, [])


    const handleSearchAutoSuggestion = (event) => {
        let keyword = event.target.value;
        setSearchValue(encodeURI(keyword))
    }


    useEffect(() => {
        setAutoSuggestionResult()
        if (searchValue && searchValue.length >= 3) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/static/fetch-suggestions-for-global-search/${searchValueRef.current}`,
                {method: "GET"}
            ).then((res) => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setAutoSuggestionResult(res.response)
                    } else if (res.result == "error") {
                        console.log("error", res.response)
                    }
                })
        } else {
            setAutoSuggestionResult("")
        }
    }, [searchValueRef.current])

    useEffect(() => {
        //console.log('useEffect defaultSearchValueRef start')
       // handleSearchAutoSuggestion(e)
        //console.log('useEffect defaultSearchValueRef')
        setSearchValue("")
        //console.log('searchValueRef =- =- =- use', searchValueRef.current)
    }, [defaultSearchValueRef.current])

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className="vast-plugin-content">
            <div className="os-header">
                <nav className="navbar navbar-expand-md bg-light os-header-bg" aria-label="OSE Header">
                    <div className="container">
                        <div className="col-lg-3 ose-header-logo-auto">
                            <Link to="/ose" className="navbar-brand d-flex os-header-logo">
                                <img className="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/ose-car-logo.png" alt="Logo" />
                            </Link>
                        </div>

                        {/* mobile search and menu icon */}
                        <div className="d-flex ose-header-mobile-icon">
                            <button className="os-search-mobile d-md-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"> <i className="bi bi-search"></i></button>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsingNavbar3">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                        </div>


                        <div className="navbar-collapse collapse col-lg-9 os-navbar-collapse ose-nav-header" id="collapsingNavbar3">
                            <ul className="navbar-nav w-100 justify-content-center os-nav-width">

                                    {containerObject?.navMenu?.ContentFolderZone?.[0]?.childRules 
                                        && containerObject.navMenu.ContentFolderZone[0].childRules.map((rule,index)=>(<MegaMenu key={index} rule={rule} index={index}/>))}
                                  
                                {/* <li className="nav-item dropdown">
                                    <Link className="nav-link dropdown-toggle" id="navbarScrollingDropdown" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"> About Us </Link>
                                    <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarScrollingDropdown">
                                        <li><Link className="dropdown-item" to="/ose/openscied-carolina-approach">OpenScied Approach</Link></li>
                                        <li><Link className="dropdown-item" to="/ose/openscied-carolina-scope-sequence">Scope and Sequence</Link></li>
                                        <li><Link className="dropdown-item" to="/ose/openscied-carolina-ccv-page">Carolina Certified Versions</Link></li>
                                        <li><Link className="dropdown-item" to="/ose/openscied-carolina-more-carolina">More About Carolina</Link></li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown">
                                    <Link className="nav-link dropdown-toggle" id="navbarScrollingDropdown" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"> Shop Products </Link>
                                    <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarScrollingDropdown">
                                        <li><Link className="dropdown-item" to="/ose/openscied/grade-6/35207.ct"> Grade 6</Link></li>
                                        <li><Link className="dropdown-item" to="/ose/openscied/grade-7/35208.ct"> Grade 7</Link> </li>
                                        <li><Link className="dropdown-item" to="/ose/openscied/grade-8/35209.ct"> Grade 8</Link></li>
                                        <li><Link className="dropdown-item" to="/ose/high-school-program/grades-9-12/38509.ct"> Grades 9 to 12</Link></li>
                                        <li><Link className="dropdown-item" to="/ose/openscied/openscied-middle-school-kits-and-refurbishment-sets/35205.ct"> Middle School Refurbishment Kits</Link></li>
                                        <li><a className="dropdown-item" href="https://stage.carolina.com/openscied-components/35206.ct" target="_blank"> OpenSciEd Components</a></li>
                                        <li><Link className="dropdown-item" to="/ose/openscied/35902.ct"> Middle School Program</Link> </li>
                                        <li><Link className="dropdown-item" to="/ose/high-school-program/38405.ct"> High School Program</Link> </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/ose/openscied-carolina-resources">Resources</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/ose/openscied-carolina-contact-page">Contact Us</Link>
                                </li> */}
                            </ul>
                            <ul className="d-none d-md-block navbar-nav me-auto w-auto justify-content-end">
                                <li className="nav-item">
                                    <form className="d-flex os-search-wrapper" onSubmit={handleSubmitData} id="mainSearchForm" formid="mainSearchForm" >
                                        <input className="os-header-search form-control" defaultValue={defaultSearchValueRef.current} id="q" size="100" name="q" onChange={handleSearchAutoSuggestion} type="search"></input>
                                        <button className="os-search-btn" id="search-submit" value="Search" type="submit">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </form>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>


               
                <div className="os-search-content d-md-none collapse" id="collapseExample">
                    <div className="os-search-field">
                        <form id="mainSearchForm" formid="mainSearchForm" method="get" className="d-flex os-search-wrapper" action="/ose/browse/product-search-results" requiressessionconfirmation="false" aria-label="Search" data-hs-cf-bound="true">
                            <div className="w-100">
                                <label for="exampleFormControlInput1" className="form-label">Search</label>
                                <input className="os-mobile-search-field form-control" placeholder="enter search terms here" maxlength="100" id="q" name="q" size="100" onChange={handleSearchAutoSuggestion} type="search" aria-label="Search" autocomplete="off" defaultValue={defaultSearchValueRef.current} />
                            </div>
                        </form>
                    </div>
                </div>

                <div className={`col-md-12 col-12 ta-results ${autoSuggestionResult && autoSuggestionResult.length > 0 ? "" : "d-none"}`}>
                    <div id="ose-ta-mobile" className={`col-md-5 ms-0 col-9 ${autoSuggestionResult ? "" : "d-none"}`}>
                        <p className='bw'>Products Suggestions: </p>
                        <div className=''>
                            {autoSuggestionResult ? autoSuggestionResult.map((product) => {
                                return (<>
                                    <span id="ta-suggession" className="sugg1">
                                        <ul className="sugg2">
                                            <Link className="row" to={product.productUrl ? product.productUrl : ""}>
                                                <div className="" style={{display:"flex"}}>
                                                    <img className="col-2 img-fluid" src={product.thumbnailImg ? product.thumbnailImg : ""} alt="ose-site-img" />
                                                    <Link className="ose-search-autocompleted col-10" to={product.productUrl ? product.productUrl : ""} dangerouslySetInnerHTML={{ __html: product.productName ? product.productName : product.productSeoName ? product.productSeoName : "" }}></Link>
                                                </div>
                                            </Link>
                                        </ul>
                                    </span>
                                </>)
                            }) : ""}
                            <div className='col-12 see-all-suggestion'>
                                <Link className="os-suggest-link" to={`/${searchPageUrlState}?q=` + encodeURIComponent(searchValueRef.current) + `&product.type=Product&&tab=p`}>See All Results</Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="os-header-search-cont">
                </div>
            </div>
        </div>
    )
}
export default CbOSEHeaderContainer